import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import * as Glob from "src/Globale";

export const _Logout: React.FC<Glob.IRouteGlobaleProps> = props => {
    useEffect(() => {
        props.SetMenu({ ...Glob.GetMenu(), Main: "" });
        props.SetSessione(new Glob.CSessione());
    }, []);

    return <Redirect to="/" />;
};



// WEBPACK FOOTER //
// ./src/inar2/pages/Logout.tsx